export default {
    items: [
        {
            name: 'Dashboard',
            url: '/dashboard',
            icon: 'fa fa-home'
        },
        {
            name: 'Mis Casos',
            url: '/casos',
            icon: 'fa fa-archive'
        },
        {
            name: 'Crear caso',
            url: '/casos/new',
            icon: 'fa fa-plus-circle'
        },
        {
            name: 'Ajustes',
            url: '/settings',
            icon: 'fa fa-sliders'
        }
    ]
};


// WEBPACK FOOTER //
// ./resources/assets/js/components/core/Sidebar/_nav.js